import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../../Components/TopNav/Topnav";

function ScanProtocal({ align, isPage = true }) {
  const { t, i18n } = useTranslation();
  const [isArabic, setIsArabic] = useState(false);

  const Component = ({ t, isArabic, align }) => {
    const unorderedListStyle = isArabic
      ? {
          margin: "10px 20px 0 0",
          color: "#000000",
          fontWeight: "normal",
        }
      : {
          margin: "10px 0 0 20px",
          color: "#000000",
          fontWeight: "normal",
        };

    const divStyles = {
      margin: "15px 0",
      textAlign: align,
      padding: "10px",
    };

    const title = { fontSize: "14px", mb: 2 };
    return (
      <div className="learning_container">
        <Typography sx={divStyles} variant="div" component="div">
          <Typography
            variant="h5"
            sx={{ mb: 2, fontWeight: "bold", fontSize: "18px" }}
            component="h1"
          >
            {t("clinic_treatment_42")}
          </Typography>
          <Typography sx={title} variant="span" component="span">
            {t("clinic_treatment_43")}
          </Typography>
          <ul style={unorderedListStyle}>
            <li>{t("clinic_treatment_44")}</li>
            <br />
            <li>{t("clinic_treatment_45")}</li>
            <br />
            <li>{t("clinic_treatment_46")}</li>
            <br />
            <li>{t("clinic_treatment_47")}</li>
            <br />
            <li>{t("clinic_treatment_49")}</li>
            <br />
            <li>{t("clinic_treatment_50")}</li>
            <br />
            <li>{t("clinic_treatment_51")}</li>
            <br />
          </ul>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "16px",
            }}
          >
            <img
              src="/assets/images/clinicpolicies5.png"
              alt=""
              className="doc_img"
            />
          </div>
          <Typography sx={title} variant="span" component="span">
            {t("clinic_treatment_52")}
          </Typography>
          <ul style={unorderedListStyle}>
            <li>{t("clinic_treatment_53")}</li>
          </ul>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "16px",
              paddingTop: "16px",
            }}
          >
            <img
              src="/assets/images/clinicpolicies6.png"
              alt=""
              className="doc_img"
            />
          </div>
          <ul style={unorderedListStyle}>
            <li>{t("clinic_treatment_54")}</li>
          </ul>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "16px",
              paddingTop: "16px",
            }}
          >
            <img
              src="/assets/images/clinicpolicies7.png"
              alt=""
              className="doc_img"
            />
          </div>
          <ul style={unorderedListStyle}>
            <li>{t("clinic_treatment_55")}</li>
          </ul>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "16px",
              paddingTop: "16px",
            }}
          >
            <img
              src="/assets/images/clinicpolicies8.png"
              alt=""
              className="doc_img"
            />
          </div>

          <ul style={unorderedListStyle}>
            <li>{t("clinic_treatment_56")}</li>
          </ul>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "16px",
              paddingTop: "16px",
            }}
          >
            <img
              src="/assets/images/clinicpolicies9.png"
              alt=""
              className="doc_img"
            />
          </div>
          <Typography sx={title} variant="span" component="span">
            <p dangerouslySetInnerHTML={{ __html: t("clinic_treatment_57") }} />
          </Typography>
        </Typography>

        <Typography sx={divStyles} variant="div" component="div">
          <Typography
            variant="h5"
            sx={{ mb: 2, fontWeight: "bold", fontSize: "18px" }}
            component="h1"
          >
            {t("clinic_treatment_58")}
          </Typography>
          <Typography sx={title} variant="span" component="span">
            <p style={{ color: "#FF0000" }}>{t("clinic_treatment_59")}</p>{" "}
            <br />
            {t("clinic_treatment_60")}
          </Typography>
        </Typography>
      </div>
    );
  };

  useEffect(() => {
    setIsArabic(i18n.language === "ar");
  }, [i18n.language]);

  return isPage ? (
    <Layout isProfile={true}>
      <Component t={t} align={align} isArabic={isArabic} />
    </Layout>
  ) : (
    <Component t={t} align={align} isArabic={isArabic} />
  );
}

export default ScanProtocal;
